import type {
  MutationClass,
  TaggingActionData,
  TaggingState,
  TaggingViewData,
} from '../../../models'

import { TaggingTypeEnum } from '../../../enums'

export class DataMutation implements MutationClass {
  static execute(
    this: void,
    state: TaggingState,
    payload: { data: TaggingViewData | TaggingActionData; type: TaggingTypeEnum },
  ): void {
    ;({
      [TaggingTypeEnum.VIEW]: () =>
        (state.data[TaggingTypeEnum.VIEW] = payload.data as TaggingViewData),
      [TaggingTypeEnum.ACTION]: () =>
        (state.data[TaggingTypeEnum.ACTION] = payload.data as TaggingActionData),
    })[payload.type]()
  }
}
